import load from '#core/load';


const table_$ = '.wysiwyg table:not(.scorecard-table__table):not(.scorecard-score-table__table)';
const wrapper_class = 'table--scroll';
const overflow_attr = 'data-is-overflowing';


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('wysiwyg')) return false;

		load.content(() => {
			wrap_tables();
		});
	},

};

export default module;
module.init();


/**
 * Wrap content tables in a horizontal scroll container so wide tables can
 * scroll instead of being cut off on narrow viewports
 */
function wrap_tables() {
	const $tables = document.querySelectorAll(table_$);
	if (!$tables.length) return false;

	$tables.forEach($table => {
		let $wrapper = $table.parentElement;

		if (!$wrapper.classList.contains(wrapper_class)) {
			$wrapper = document.createElement('div');
			$wrapper.className = wrapper_class;
			$table.parentNode.insertBefore($wrapper, $table);
			$wrapper.appendChild($table);
		}

		watch_overflow($wrapper, $table);
	});
}


/**
 * Make the wrapper keyboard-scrollable only while the table actually overflows
 * @param {HTMLElement} $wrapper
 * @param {HTMLElement} $table
 */
function watch_overflow($wrapper, $table) {
	const update = () => {
		const is_overflowing = $table.scrollWidth > $wrapper.clientWidth + 1;

		$wrapper.toggleAttribute(overflow_attr, is_overflowing);

		if (is_overflowing) {
			$wrapper.setAttribute('tabindex', '0');
		} else {
			$wrapper.removeAttribute('tabindex');
		}
	};

	update();

	if (typeof ResizeObserver === 'function') {
		new ResizeObserver(update).observe($wrapper);
	}
}
